import { action, computed, makeObservable, observable } from 'mobx';
import type { TemplatesStore } from '../../stores/TemplatesStore';

export class ViewModalStore {
  public mode: 'desktop' | 'mobile' = 'desktop';
  public id: string | undefined = undefined;

  constructor(private templatesStore: TemplatesStore) {
    makeObservable(this, {
      mode: observable,
      id: observable,
      modalState: computed,
      openTemplate: action,
      closeTemplate: action,
      toggleMode: action,
    });
  }

  openTemplate(id: string | undefined) {
    this.id = id;
  }

  closeTemplate() {
    this.openTemplate(undefined);
  }

  toggleMode() {
    this.mode = this.mode === 'desktop' ? 'mobile' : 'desktop';
    return this.mode;
  }

  next(diff: number) {
    if (!this.id || !this.canNext(diff)) {
      return;
    }
    const index = this.templatesStore.items.findIndex((t) => t.id === this.id);
    const nextIndex = index + diff;

    const template = this.templatesStore.items[nextIndex];
    if (!template) {
      return;
    }

    this.openTemplate(template.id);
  }

  canNext(diff: number) {
    if (!this.id) {
      return false;
    }
    const index = this.templatesStore.items.findIndex((t) => t.id === this.id);
    if (index < 0) {
      // cannot find template by given id
      return false;
    }
    const nextIndex = index + diff;
    if (nextIndex > this.templatesStore.items.length - 1 || nextIndex < 0) {
      return false;
    }
    return true;
  }

  get modalState() {
    const id = this.id;
    if (!id) {
      return undefined;
    }
    const index = this.templatesStore.items.findIndex((t) => t.id === id);
    if (index < 0) {
      return undefined;
    }
    const template = this.templatesStore.items[index];
    if (!template) {
      return undefined;
    }
    const prevTemplate = this.templatesStore.items[index - 1];
    const nextTemplate = this.templatesStore.items[index + 1];
    return {
      prevTemplate,
      template,
      index,
      nextTemplate,
      mode: this.mode,
    };
  }
}
